import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/services/calc/page.jsx");
